import React, { Component } from "react";
import "./AddUser.css";
import {
  Card,
  Row,
  Col,
  Spin,
  Button,
  Select,
  Input,
  Table,
  Radio,
  DatePicker,
  Tooltip,
  notification,
} from "antd";
import { Form } from "@ant-design/compatible";
import moment from "moment";
import Config from "../../config";
import { updateUserList } from "../../store/broadcaster/BroadcastRegister";
import { CloseCircleFilled, CodeSandboxCircleFilled } from "@ant-design/icons";
import GroupAdmin from "./GroupAdmin";
import ProviderTaxid from "./ProviderTaxid"
import AddIPAs2 from "./AddIPAs2";
import axios from "axios";
import Item from "antd/es/list/Item";

class editUser extends Component {
  constructor(props) {
    super(props);
    console.log("editUser props",props)
    this.state = {
      EditClickForIPAs: false,
      UpdateClickForIPAs: false,
      isLoading: false,
      isLoadingApprove: false,
      oldCombinations: [],
      addTax: false,
      addNpi: false,
      combinations: [],
      providercombination:[],
      Existingprovidercombination:[],
      combinations1: [],
      storeByDefaultIPAs: [],
      selIPAs: [],
      taxIDandNPIDetailsByIPA: [],
      existingRoles: [],
      SelectValue: " ",
      Geticon: false,
      Taxclicked: false,
      Npiclicked: false,
      disabledaccordingtoinput: true,
      disabledaccordingtoinputTax: true,
      disabledNPI: false,
      disabled: false,
      clicked: false,
      ProviderNPIs: [],
      TaxID: [],
      AddRole: [],
      DeleteRole: [],
      DeleteNPI: [],
      DeleteTaxID: [],
      NewRole: [],
      message: "",
      disabled: false,
      disableRole: "",
      deleteTaxNpiMapping: [],
      addedNpi: "",
      addedTaxId: "",
      accessDeniedForTaxId: false,
      disableButton: false,
      accessDeniedForNpi: false,
      EligibilityOnly: "",

      IsDSNP: 1,

      existingNPIList:[],
      readytosaveNPIlist:[],
      npiListForGroupUserNpi: [],


    };
  }

  handleIPACancle = async () => {
    this.props.getType("List", "RegisteredUser");
    this.setState({
      SelectValue: "",
      CurrentAge: "",
      AddRole: [],
      Geticon: false,
      clicked: false,
      disableButton: false,
    });
  };
  handleIPASubmit = async (button) => {


   this.setState({disableButton: true})

    this.setState ({
      isLoadingApprove:true
    })


    let body = {
      RegistrationIDs: [
        {
          ID: this.props.RegistrationID
        }
      ],
      PlanName: sessionStorage.getItem("planName"),
      Status: button,
      IsUserAdmin: this.state.UserType === 1 ? true : false,
      IsEligibilityOnly: this.state.EligibilityOnly === 'yes' ? true : false,
      ApprovedBy: sessionStorage.getItem("userEmail"),
    };
    body = await JSON.stringify(body);

    let response = await fetch(`${Config.api}/UpdateIPAUserStatus`, {
      method: "PUT",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: body,
    });

    response = await response.json();

    if (response) {
      notification.open({
        description: response.Message,
      });
    }
    
    this.setState({
      SelectValue: "",
      CurrentAge: "",
      AddRole: [],
      Geticon: false,
      clicked: false,
      disableButton: false,
      isLoadingApprove:false
    });
    this.props.getType("List", "RegisteredUser");
  };


  setProviderCombinations = (items)=>{
    console.log("items-2",items)
    this.setState({
      providercombination: items || [],
      combinations:items && items.length > 0 ? items :[],
      ProviderNPIs: items && items.length > 0 ? items[0].npis : [],
      TaxID: items && items.length > 0 ? items[0].taxId : "", 
    });
  }

  async componentDidMount() {
    console.log("props", this.props.userData);
    let userData = this.props.userData;
    let Roles = [];
    // console.log("Data props", this.props.activeTab, "User Data ", userData);
    if (userData.Roles) {
      Roles = userData.Roles.split("|");
    }

    console.log("Roles",Roles)
    let anotherRole = Roles.filter((item) => item != "User Admin");

    if (
      userData.TaxNPIMappings &&
      userData.TaxNPIMappings.length > 0 &&
      !userData.IPATaxMappings.length > 0
    ) {
      for (let mapping of userData.TaxNPIMappings) {
        let _npis = mapping.NPIList.split(",");
        let npis = [];
        for (let item of _npis) {
          npis.push({ npi: item, delete: false, save: true });
        }
        this.setState({
          existingNPIList: userData.TaxNPIMappings.map(item => ({
            TaxID: item.TaxID,
            NPIList: item.NPIList ? item.NPIList.split(',') : []  // handle empty case safely
          }))
        });
        this.state.combinations.push({
          taxId: mapping.TaxID,
          npis: npis,
          delete: false,
          save: true,
        });
      }
    }
    if (userData.IPATaxMappings && userData.IPATaxMappings.length > 0) {
      // console.log("dataofIPA ",userData.IPATaxMappings)
      // const filteredArray = userData.IPATaxMappings.filter(entry => entry.IPA !== "null" && entry.IPA !== null)
      // .map(entry => ({ IPA: entry.IPA }));
      // console.log("filteredArray",filteredArray)
      // this.setState({
      //   combinations1: filteredArray
      // });

      const convertedArray = userData.IPATaxMappings.map(entry => {
        const [ipa] = entry.split(':').map(item => item.trim());
        return { ipa };

      });

      this.setState({
        combinations1: convertedArray,
        storeByDefaultIPAs: convertedArray,
      });
    }

    if (userData.NPIList) {
      console.log("npiList", userData.NPIList);
    
      // Get unique, valid NPIs from the saved NPI list
      const savedNpis = [
        ...new Set(
          userData.NPIList
            .split("|")
            .map((item) => item.trim())
            .filter((item) => item !== "")
        ),
      ];
    
      // Continue only if at least one NPI is available
      if (savedNpis.length > 0) {
        const axiosConfig = {
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
            Accept: "application/json",
          },
        };
    
        const plan = sessionStorage.getItem("planName");
    
        const url = `${Config.api}/ListNPIBasedOnPlan?PlanName=${plan}`;
    
        // API expects an array of NPIs in NpiNumber
        const payload = {
          NpiNumber: savedNpis,
        };
    
        try {
          const response = await axios.post(url, payload, axiosConfig);
          console.log("rrsss",response?.data?.Details)
    
          const npiList = response?.data?.Details || [];
          this.setState({npiListForGroupUserNpi: npiList})

    
          // Match API results with the saved NPIs
          const npis = npiList
            .filter((item) =>
              savedNpis.includes(String(item.npiNumber))
            )
            .map((item) => {
              const name =
                item.providerType?.toLowerCase() === "physician"
                  ? `${item.firstName || ""}${
                      item.middleName ? ` ${item.middleName}` : ""
                    } ${item.lastName || ""}`.trim()
                  : item.facilityName;

                  console.log("name", name)
    
              return {
                npi: item.npiNumber,
                name,
                save: true,
                delete: false,
              };
            });
    
          // Add the NPI-only combination
          this.setState((prevState) => {
            const existingCombinations = prevState.combinations || [];
    
            // Replace the existing None combination instead of duplicating it
            const otherCombinations = existingCombinations.filter(
              (item) => item.taxId !== "None"
            );
    
            return {
              combinations: [
                ...otherCombinations,
                {
                  taxId: "None",
                  npis,
                  delete: false,
                  save: true,
                },
              ],
            };
          });
    
          console.log("ListNPIBasedOnPlan response:", response.data);
          console.log("NPI combination:", npis);
        } catch (error) {
          console.error(
            "Error calling ListNPIBasedOnPlan:",
            error.response?.data || error.message
          );
        }
      }
    }
    if (Roles.includes("Provider")) {
      
      console.log("userData",userData)
      if (userData.NPI) {
        let npis = [];
        for (let item of userData.NPI.split("|")) {
          npis.push({ npi: item, delete: false, save: true });
        }
        this.state.combinations.push({
          taxId: [],
          npis: [],
          delete: "",
          save: "",
        });
        this.state.providercombination.push({
          taxId: userData.TaxID,
          npis: npis,
          delete: false,
          save: true,
        });
        this.state.Existingprovidercombination.push({
          taxId: userData.TaxID,
          npis: npis.map((n) => ({ ...n })), // independent copy, so edits don't change "existing"
          delete: false,
          save: true,
        });
      }

      console.log("////////////////////")
      console.log(this.state.combinations)
      console.log(this.state.providercombination)
      console.log(this.state.Existingprovidercombination)
    }

    this.setState({
      IsDSNP: Number(userData.IsDSNP) ? 1 : 0,
      oldCombinations: this.state.combinations,
      combinations: this.state.combinations,
      UserType: Roles.includes("User Admin") ? 1 : 2,
      EligibilityOnly: userData.EligibilityOnlyFlag ? "yes" : "no",
      SelectValue: anotherRole.length > 0 ? anotherRole[0] : "Not Required",
      RoleWithOptions: Roles.includes("Plan Admin")
        ? "PA1"
        : Roles.includes("Group User")
        ? "GA1"
        : Roles.includes("Provider")
        ? "PR1"
        : Roles.includes("IPA User")
        ? "IPA User"
        : "NR1",
      existingRoles: Roles,
      addTax: userData.TaxID ? true : false,
      addNpi: userData.NPI ? true : false,
      disabledNPI: userData.NPI ? true : false,
      ProviderNPIs: userData.NPI ? userData.NPI.split("|") : [],
      TaxID: userData.TaxID ? userData.TaxID.split("|") : [],
    });
  }

  isNumber(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  setDeletedCombinations = (item) => {
    this.setState({
      deleteTaxNpiMapping: item
        ? [...this.state.deleteTaxNpiMapping, item]
        : [...this.state.deleteTaxNpiMapping],
    });
  };

  savedTaxidAndNPIList = (list) =>{
    this.setState({
      readytosaveNPIlist:list
    }) 
    
  }

  onChange = async (e, type) => {
    await this.setState({
      UserType: type === "admin" ? e.target.value : this.state.UserType,
      EligibilityOnly:
        type === "e&b" ? e.target.value : this.state.EligibilityOnly,
      IsDSNP: type === "isDsnp" ? e.target.value : this.state.IsDSNP,
    });
  };

  ChangeWithOptions = async (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === "GA1") {
      if (this.state.oldCombinations.length === 0) {
        this.setState({
          ProviderNPIs: [],
          combinations: [],
        });
     } else{
        this.setState({
          ProviderNPIs: [],
          combinations: this.state.oldCombinations,
        });
      }
    }

    if (selectedValue === "PR1") {
      this.setState({
        ProviderNPIs: [],
        combinations: [],
      });
    }

    const selectedRole =
      selectedValue === "PR1"
        ? "Provider"
        : selectedValue === "GA1"
          ? "Group User"
          : selectedValue === "PA1"
            ? "Plan Admin"
            : selectedValue === "IPA User"
              ? "IPA User"
              : "Not Required";

    await this.setState({
      RoleWithOptions: selectedValue,
      SelectValue: selectedRole,

      // Reset DSNP when role changes
      IsDSNP: 1,
    });

    console.log("Selected Radio:", selectedValue);
    console.log("Selected Role:", selectedRole);
  };

  handleChangeNPI = (e) => {
    console.log("handleChangeNPI", e.target.value);
    let regex = new RegExp(/^[0-9]*$/);
    this.setState({ accessDeniedForNpi: false });
    if (e.target.value.length == 10 && regex.test(e.target.value)) {
      const eNpi = e.target.value;
      this.setState({
        disabledaccordingtoinput: false,
        Npiclicked: true,
        addedNpi: eNpi,
      });
    } else if (e.target.value.length === 0) {
      console.log("else if");
      this.setState({
        disabledaccordingtoinput: false,
        Npiclicked: true,
      });
    } else {
      console.log("else");
      this.setState({
        disabledaccordingtoinput: true,
        Npiclicked: true,
      });
    }
    console.log("Entered NPI: ", this.state.addedNpi);
  };

  handleChangeTax = (e) => {
    let regex = new RegExp(/^[0-9]*$/);
    this.setState({ accessDeniedForTaxId: false });
    if (e.target.value.length == 9 && regex.test(e.target.value)) {
      this.setState({
        disabledaccordingtoinputTax: false,
        Taxclicked: true,
        addedTaxId: e.target.value,
      });
    } else if (e.target.value.length === 0) {
      this.setState({
        disabledaccordingtoinputTax: false,
        Taxclicked: true,
      });
    } else {
      this.setState({
        disabledaccordingtoinputTax: true,
        Taxclicked: true,
      });
    }
  };

  setCombinations = (items) => {
    this.setState({
      combinations: items && items.length > 0 ? items : [],
    });
  };
  setCombinations1 = (items) => {
    this.setState({
      combinations1: items && items.length > 0 ? items : [],
    });
  };
  SeteditClickForIPAs = (item) => {
    this.setState({
      EditClickForIPAs: item,
    });
  };
  SetupdateClickForIPAs = (item) => {
    this.setState({
      UpdateClickForIPAs: item,
    });
  };

  setTaxIDandNPIDetailsByIPA = (items) => {
    this.setState({
      taxIDandNPIDetailsByIPA:
        items && items.Details.length > 0 ? items.Details : [],
    });
  };

  handleSubmit = () => {
    // e.preventDefault();
    console.log(this.state.combinations)
    let TenantID = sessionStorage.getItem("Tanent");
    TenantID = parseInt(TenantID, 10);
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({
          isLoading: true,
        });
        if (values.MiddleName === "") {
          values.Name = values.FirstName + " " + values.LastName;
        } else {
          values.Name =
            values.FirstName + " " + values.MiddleName + " " + values.LastName;
        }
        values.AddNPI = [];

        if (this.state.ProviderNPIs.length > 0 && this.state.addNpi && !this.state.existingRoles.includes("Provider")) {

          values.AddNPI = this.state.ProviderNPIs.map((item) => {
            return { NPINumber: item };
          });
        }

        values.DeleteNPI = [];
        if (this.state.DeleteNPI.length > 0) {
          values.DeleteNPI = this.state.DeleteNPI.map((item) => {
            return { NPINumber: item };
          });
        }

        if(this.state.SelectValue !== "Provider" ){
        values.AddTax = [];
        if ( Array.isArray(this.state.TaxID) && this.state.TaxID.length > 0 && this.state.addTax) {
          values.AddTax = this.state.TaxID.map(item => ({
             TaxNumber: item,
            }));
          }
        }

        values.DeleteTax = [];
        if (this.state.DeleteTaxID.length > 0) {
          values.DeleteTax = this.state.DeleteTaxID.map((item) => {
            return { TaxNumber: item };
          });
        }

        let roles = [];
        values.AddRoleName = [];
        values.DeleteRoleName = [];

        if (this.state.UserType === 1) roles.push("User Admin");
        if (this.state.SelectValue && this.state.SelectValue != "Not Required")
          roles.push(this.state.SelectValue);

        for (let role of this.state.existingRoles) {
          if (roles.includes(role)) values.AddRoleName.push({ Name: role });
          else values.DeleteRoleName.push({ Name: role });
        }

        for (let role of roles) {
          //roles can contain extra roles
          if (!this.state.existingRoles.includes(role))
            values.AddRoleName.push({ Name: role });
          // else values.DeleteRoleName.push({Name: role})
        }

        values.DeleteTaxNpiMapping = [];
        values.TaxNpiMapping = [];
        values.DeleteIPAMapping = [];
        values.IPATaxIDMapping = [];
        // when user rols is plan admin
        console.log(" current roles",roles)
        if (roles.includes("Plan Admin")) {
          values.AddNPI =[]
          values.AddTax=[]
            if(this.state.ProviderNPIs.length > 0){
              values.DeleteNPI =  this.state.ProviderNPIs.map((item)=>{
                  return { NPINumber: item };
              })
            }
            if(this.state.TaxID.length > 0){
              values.DeleteTax = this.state.TaxID.map((item) => {
                return { TaxNumber: item };
            })

           }

           if( this.state.combinations1 ){

           values.DeleteIPAMapping = this.state.combinations1
           }
        }
        if (roles.includes("Provider")) {
          // providercombination is what the Provider UI edits; fall back to combinations if empty
          const providerSource =
            this.state.providercombination && this.state.providercombination.length > 0
              ? this.state.providercombination
              : this.state.combinations.filter(
                  (c) => c.taxId && !Array.isArray(c.taxId) && c.taxId !== "None" && c.taxId !== "Deleted"
                );
        
          const seen = new Set();
          const validNPIs = [];
          providerSource.forEach((comb) => {
            (comb.npis || []).forEach((n) => {
              if (n.delete === true) return; // removed in UI
              const v = n.npi != null ? String(n.npi) : "";
              if (v && !seen.has(v)) {
                seen.add(v);
                validNPIs.push({ NPINumber: v });
              }
            });
          });
        
          values.AddNPI = validNPIs;
        
          values.AddTax = providerSource.map((comb) => ({
            TaxNumber: comb.taxId,
          }));
        }
        // values.TaxNpiMapping = mapping;
        // values.IPATaxIDMapping = mapping2;
        // values.TaxNpiMapping = [
        //   {
        //     "TaxID": "204881619",
        //     "NPIList": [
        //       {
        //         "NPINumber": "1477657708"
        //       },
        //       {
        //         "NPINumber": 1942368873
        //       }
        //     ]
        //   },
        //   {
        //     "TaxID": "788599848",
        //     "NPIList": [
        //       {
        //         "NPINumber": "4789088578"
        //       }
        //     ]
        //   },
        //   {
        //     "TaxID": "898089769",
        //     "NPIList": [
        //       {
        //         "NPINumber": null
        //       }
        //     ]
        //   }
        // ];
        // values.IPATaxIDMapping = [
        //   {
        //     "IPA": "Access 2 Health Care, LLC",
        //     "TaxIDList": [
        //       {
        //         "TaxNumber": "204881619"
        //       },
        //       {
        //         "TaxNumber": "204881619"
        //       },
        //       {
        //         "TaxNumber": "788599848"
        //       },
        //       {
        //         "TaxNumber": "898089769"
        //       }
        //     ]
        //   }
        // ];

        let taxCombination = this.state.combinations.filter(
          (item) => item.taxId != "None"
        );
        let mapping = [];
        let mapping2 = [];

        if (
          taxCombination &&
          taxCombination.length > 0 &&
          this.state.SelectValue === "Group User"
        ) {     
          console.log("existingNPIList",this.state.existingNPIList)
          console.log("readytosaveNPIlist",this.state.readytosaveNPIlist)
          if(this.state.oldCombinations.length >0 ){

            var deleteTaxNpiMapping = this.state.oldCombinations.map(item => ({
              TaxID: item.taxId,
              NPIList: item.npis.map(npiItem => ({
                NPINumber: Number(npiItem.npi) // convert string to number
              }))
            }));
            values.DeleteTaxNpiMapping = deleteTaxNpiMapping
            this.setState({
              deleteTaxNpiMapping: this.state.oldCombinations
               
            });
          }

          var mergedResult = this.state.readytosaveNPIlist
          .filter(item => item.taxId && item.taxId !== "None") // Remove None
          .map(item => {
            const taxId = item.taxId;
            const existing = this.state.existingNPIList.find(e => e.TaxID === taxId);
        
            if (!existing) {
              //  Newly added TAX → save:false delete:false
              return {
                taxId,
                npis: item.npis.map(n => ({
                  npi: String(n.npi),
                  delete: false,
                  save: false
                }))
              };
            }
        
            const existingNPIs = existing.NPIList.map(String);
            const newNPIs = item.npis.map(n => String(n.npi));
        
            //  Common NPIs (already exist)
            const common = existingNPIs
              .filter(npi => newNPIs.includes(npi))
              .map(npi => ({
                npi,
                delete: false,
                save: true
              }));
        
            //  Added NPIs (new in readytosave list)
            const added = newNPIs
              .filter(npi => !existingNPIs.includes(npi))
              .map(npi => ({
                npi,
                delete: false,
                save: false
              }));
        
            //  Deleted NPIs (missing from new list)
            const deleted = existingNPIs
              .filter(npi => !newNPIs.includes(npi))
              .map(npi => ({
                npi,
                delete: true,
                save: true
              }));    
            return {
              taxId,
              npis: [...common, ...added, ...deleted]
            };
          });     
         
          // Create a map of result by taxId for fast lookup
          const resultMap = {};
          mergedResult.forEach(r => {
            resultMap[String(r.taxId)] = r.npis;
          });

           console.log("updated result",mergedResult);

          // Update taxCombination in place
          taxCombination.forEach(tc => {
            const newNpis = resultMap[String(tc.taxId)];
            if (newNpis) {
              tc.npis = newNpis;  // directly replace npis
            }
          });
          for (let item of taxCombination) {
            let _npis = [];
            let _delNpis = [];

            if (!item.delete && !item.save) {
              //when item (taxID) is new
              for (let npi of item.npis) {
                if (!npi.delete && !npi.save) {
                  // all newly added/ unsaved npis will go
                  _npis.push({ NPINumber: npi.npi });
                }
                // if (npi.groupNPI && !npi.delete && !npi.save) {
                //   _npis.push({ NPINumber: npi.groupNPI });
                // }
              }
            }

            if (!item.delete && item.save) {
              //saved taxID
              for (let npi of item.npis) {
                console.log(item)
                if (!npi.delete && !npi.save) {
                  // all newly added/ unsaevd npis will go
                  _npis.push({ NPINumber: npi.npi });
                }
                // if (!npi.delete && !npi.save && npi.groupNPI) {
                //   // all newly added/ unsaevd npis will go
                //   _npis.push({ NPINumber: npi.groupNPI });
                // }
                if (npi.delete && npi.save) {
                  // all npis which are already saved but deleted now
                  _delNpis.push({ NPINumber: npi.npi });
                }
                // if (npi.delete && npi.save && npi.groupNPI) {
                //   // all npis which are already saved but deleted now
                //   _delNpis.push({ NPINumber: npi.groupNPI });
                // }
              }
            }

            if (item.delete && item.save) {
              //saved taxID & now deleted
              for (let npi of item.npis) {
                if (npi.save) {
                  // all saevd npis will be deleted from BE
                  _delNpis.push({ NPINumber: npi.npi });
                }
                // if (npi.save && npi.groupNPI) {
                //   // all saevd npis will be deleted from BE
                //   _delNpis.push({ NPINumber: npi.groupNPI });
                // }
              }
            }
            if (_npis.length > 0)
              values.TaxNpiMapping.push({ TaxID: item.taxId, NPIList: _npis });
            if (_delNpis.length > 0)
              values.DeleteTaxNpiMapping.push({
                TaxID: item.taxId,
                NPIList: _delNpis,
              });
          }
        }

        if (
          taxCombination &&
          taxCombination.length > 0 &&
          this.state.SelectValue !== "Group User"
        ) {
          for (let item of taxCombination) {
            let _npis = [];
            let _delNpis = [];

            if (!item.delete && !item.save) {
              //when item (taxID) is new
              for (let npi of item.npis) {
                if (!npi.delete && !npi.save) {
                  // all newly added/ unsaved npis will go
                  _npis.push({ NPINumber: npi.npi });
                }
                // if (npi.groupNPI && !npi.delete && !npi.save) {
                //   _npis.push({ NPINumber: npi.groupNPI });
                // }
              }
            }

            if (!item.delete && item.save) {
              //saved taxID
              for (let npi of item.npis) {
                console.log(item)
                if (!npi.delete && !npi.save) {
                  // all newly added/ unsaevd npis will go
                  _npis.push({ NPINumber: npi.npi });
                }
                if (!npi.delete && npi.save) {
                  // all newly added/ unsaevd npis will go
                  _npis.push({ NPINumber: npi.npi });
                }
                // if (!npi.delete && !npi.save && npi.groupNPI) {
                //   // all newly added/ unsaevd npis will go
                //   _npis.push({ NPINumber: npi.groupNPI });
                // }
                if (npi.delete && npi.save) {
                  // all npis which are already saved but deleted now
                  _delNpis.push({ NPINumber: npi.npi });
                }
                if (!npi.delete && npi.save) {
                  // all newly added/ unsaevd npis will go
                  _delNpis.push({ NPINumber: npi.npi });
                }
                // if (npi.delete && npi.save && npi.groupNPI) {
                //   // all npis which are already saved but deleted now
                //   _delNpis.push({ NPINumber: npi.groupNPI });
                // }
              }
            }

            if (item.delete && item.save) {
              //saved taxID & now deleted
              for (let npi of item.npis) {
                if (npi.save) {
                  // all saevd npis will be deleted from BE
                  _delNpis.push({ NPINumber: npi.npi });
                }
                // if (npi.save && npi.groupNPI) {
                //   // all saevd npis will be deleted from BE
                //   _delNpis.push({ NPINumber: npi.groupNPI });
                // }
              }
            }
            if (_npis.length > 0)
             // values.TaxNpiMapping.push({ TaxID: item.taxId, NPIList: _npis });
            if (_delNpis.length > 0)
              values.DeleteTaxNpiMapping.push({
                TaxID: item.taxId,
                NPIList: _delNpis,
              });
          }

        }

        if (this.state.SelectValue === "IPA User") {
          // console.log("combinations}}", this.state.combinations1);
          // console.log(
          //   "taxIDandNPIDetailsByIPA::",
          //   this.state.taxIDandNPIDetailsByIPA
          // );
          let IPAsCombination = this.state.combinations1.filter(
            (item) => item.IPA != "None"
          );
          // console.log("IPAsCombinatio:", IPAsCombination);

          if (IPAsCombination && IPAsCombination.length > 0) {
            // console.log(
            //   "this.state.taxIDandNPIDetailsByIPA: ",
            //   this.state.taxIDandNPIDetailsByIPA
            // );
            const datanew = this.state.taxIDandNPIDetailsByIPA;
            //  const data = this.state.TaxIDList.map(({ GroupTaxId }) => ({ GroupTaxId }))
            //   console.log("asa ", datanew);
            const transformedDataForNPIs = datanew.reduce((result, obj) => {
              const existingItem = result.find(
                (item) => item.TaxID === obj.groupTaxId
              );

              if (existingItem) {
                existingItem.NPIList.push({ NPINumber: obj.npiNumber });
              } else {
                result.push({
                  TaxID: obj.groupTaxId,
                  NPIList: [

                    // { NPINumber: obj.groupNPI },
                    { NPINumber: obj.npiNumber.toString() }
                  ].filter(obj => obj.NPINumber !== null),

                });
              }

              return result;
            }, []);
            mapping = transformedDataForNPIs;

            let _taxid = [];
            // for (let item of IPAsCombination) {
            //   mapping2.push({ IPA: item.IPA, TaxIDList: _taxid }); // TaxIDList: _taxid
            //   this.state.taxIDandNPIDetailsByIPA.forEach((obj) => {
            //     _taxid.push({ TaxNumber: obj.GroupTaxId });
            //   });
            // }

            const transformedDataForIPA = this.state.taxIDandNPIDetailsByIPA.reduce((result, item) => {
              const existingIPAIndex = result.findIndex(obj => obj.IPA === item.ipa);


                if (existingIPAIndex !== -1) {

                result[existingIPAIndex].TaxIDList.push({ TaxNumber: item.groupTaxId });

                } else {
                  result.push({

                  IPA: item.ipa,
                  TaxIDList: [{ TaxNumber: item.groupTaxId }]

                  });
                }

                return result;
              }, []);

            mapping2 = transformedDataForIPA
            console.log("IPATaxIDMapping: ", mapping2);

          }
          values.TaxNpiMapping = mapping;
          values.IPATaxIDMapping = mapping2;
          const DeleteIPAMapping = [];
          // console.log("mapping2",mapping2)
          if (this.state.UpdateClickForIPAs == true) {
            for (const ipa of this.state.storeByDefaultIPAs) {

                  const foundMapping = mapping2.find((mapping2) => mapping2.IPA === ipa.ipa);


              if (!foundMapping) {
                DeleteIPAMapping.push({

                      IPA: ipa.ipa,

                  //  TaxIDList: [{ TaxNumber: ipa.GroupTaxId }],
                });
              }
            }
            values.DeleteIPAMapping = DeleteIPAMapping;
          }
          values.DeleteIPAMapping = DeleteIPAMapping;
          //   if(this.state.EditClickForIPAs == true){
          //   for (const ipa of this.state.storeByDefaultIPAs) {
          //     const foundMapping = mapping2.find((mapping2) => mapping2.IPA === ipa.IPA);

          //     if (!foundMapping) {
          //       DeleteIPAMapping.push({
          //         IPA: ipa.IPA,
          //       //  TaxIDList: [{ TaxNumber: ipa.GroupTaxId }],
          //       });
          //     }
          //   }
          //   values.DeleteIPAMapping = DeleteIPAMapping
          // }else{
          //   if(this.state.UpdateClickForIPAs == true)
          //   {
          //     for (const ipa of this.state.storeByDefaultIPAs) {
          //       const foundMapping = mapping2.find((mapping2) => mapping2.IPA === ipa.IPA);

          //       if (!foundMapping) {
          //         DeleteIPAMapping.push({
          //           IPA: ipa.IPA,
          //         //  TaxIDList: [{ TaxNumber: ipa.GroupTaxId }],
          //         });
          //       }
          //     }
          //     values.DeleteIPAMapping = DeleteIPAMapping
          //   }
          //   values.DeleteIPAMapping = []
          // }
        }
        // values.TaxNpiMapping = mapping;
        // values.IPATaxIDMapping = mapping2;
        // for combination having tax ID as none
        let npisCombination = this.state.combinations.filter(
          (item) => item.taxId === "None"
        )[0];

        if (
          npisCombination &&
          (this.state.SelectValue === "Group User" ||
            this.state.SelectValue === "IPA User")
        ) {
          values.AddNPI = [];
          values.DeleteNPI = [];
          if (this.state.SelectValue !== "IPA User") {
            values.DeleteIPAMapping = this.state.combinations1;
          }

          if (!npisCombination.delete && !npisCombination.save) {
            //when item is new
            for (let npi of npisCombination.npis) {
              if (!npi.delete && !npi.save) {
                // all newly added/ unsaved npis will go
                values.AddNPI.push({ NPINumber: npi.npi });
                if (npi.GroupNPI && !npi.delete && !npi.save) {
                  values.AddNPI.push({ NPINumber: npi.GroupNPI });
                }
              }
            }
          }
          if (!npisCombination.delete && npisCombination.save) {
            //saved item
            for (let npi of npisCombination.npis) {
              if (!npi.delete && !npi.save) {
                // all newly added/ unsaved npis will go
                values.AddNPI.push({ NPINumber: npi.npi });
              }
              if (npi.GroupNPI && !npi.delete && !npi.save) {
                values.AddNPI.push({ NPINumber: npi.GroupNPI });
              }
              if (npi.delete && npi.save) {
                // all npis which are already saved but deleted now
                values.DeleteNPI.push({ NPINumber: npi.npi });
              }
            }
          }

          let npiDelCombination = this.state.combinations.filter(
            (item) => item.taxId === "Deleted"
          )[0];
          if (npiDelCombination) {
            if (npiDelCombination.delete && npiDelCombination.save) {
              //saved taxID
              for (let npi of npiDelCombination.npis) {
                if (npi.save) {
                  // all npis which are already saved in DB
                  values.DeleteNPI.push({ NPINumber: npi.npi });
                }
                if (npi.save && npi.GroupNPI) {
                  values.DeleteNPI.push({ NPINumber: npi.GroupNPI });
                }
              }
            }
          }
        }
        // switch from GA to Provider & vice versa
        if (
          (this.state.existingRoles.includes("Group User") &&
            this.state.SelectValue !== "Group User" &&
            this.state.SelectValue == "IPA User") ||
          (this.state.existingRoles.includes("IPA User") &&
            this.state.SelectValue !== "IPA User" &&
            this.state.SelectValue == "Group User") ||
          (this.state.existingRoles.includes("IPA User") &&
            this.state.SelectValue !== "IPA User" &&
            this.state.SelectValue == "Provider") ||
          (this.state.existingRoles.includes("Group User") &&
            this.state.SelectValue == "Provider" &&
            this.state.SelectValue !== "Group User") ||
          (this.state.existingRoles.includes("Provider") &&
            this.state.SelectValue !== "Provider" &&
            this.state.SelectValue == "Group User") ||
          (this.state.existingRoles.includes("Provider") &&
            this.state.SelectValue !== "Provider" &&
            this.state.SelectValue == "IPA User")
        ) {
          if (this.state.SelectValue !== "IPA User") {
            values.DeleteIPAMapping = this.state.combinations1;
          }
          let taxCombination = this.state.combinations.filter(
            (item) => item.taxId != "None" && item.taxId != "Deleted"
          );
          if (taxCombination && taxCombination.length > 0) {
            for (let item of taxCombination) {
              let _npis = [];
              let _delNpis = [];

              if (!item.delete && item.save) {
                //saved taxID
                for (let npi of item.npis) {
                  if (npi.save) {
                    // all npis which are already saved in DB
                    _delNpis.push({ NPINumber: npi.npi });
                  }
                  if (npi.save && npi.GroupNPI) {
                    _delNpis.push({ NPINumber: npi.GroupNPI });
                  }
                }
              }

              if (item.delete && item.save) {
                //saved taxID & now deleted
                for (let npi of item.npis) {
                  if (npi.save) {
                    // all saevd npis will be deleted from BE
                    _delNpis.push({ NPINumber: npi.npi });
                  }
                  if (npi.save && npi.GroupNPI) {
                    _delNpis.push({ NPINumber: npi.GroupNPI });
                  }
                }
              }
              if (_npis.length > 0)
                values.TaxNpiMapping.push({
                  TaxID: item.taxId,
                  NPIList: _npis,
                });
              if (_delNpis.length > 0)
                values.DeleteTaxNpiMapping.push({
                  TaxID: item.taxId,
                  NPIList: _delNpis,
                });
            }
          }

          let npiCombination = this.state.combinations.filter(
            (item) => item.taxId === "None"
          )[0];
          if (npiCombination) {
            //switching from GA to provider
            if (!npiCombination.delete && npiCombination.save) {
              //saved taxID
              for (let npi of npiCombination.npis) {
                if (npi.save) {
                  // all npis which are already saved in DB
                  values.DeleteNPI.push({ NPINumber: npi.npi });
                }
              }
            }
          }

          // handle delete Comb for ADD NPI
          let npiDelCombination = this.state.combinations.filter(
            (item) => item.taxId === "Deleted"
          )[0];
          if (npiDelCombination) {
            if (npiDelCombination.delete && npiDelCombination.save) {
              //saved taxID
              for (let npi of npiDelCombination.npis) {
                if (npi.save) {
                  // all npis which are already saved in DB
                  values.DeleteNPI.push({ NPINumber: npi.npi });
                }
              }
            }
          }
        }

        //earlier he was provider but not now
        if (
          this.state.existingRoles.includes("Provider") &&
          this.state.SelectValue != "Provider"
        ) {
          values.AddTax = [];
          if (!values.AddNPI.some((item) => item.NPINumber)) {
            values.AddNPI = [];
          }

          if (this.state.ProviderNPIs.length > 0 && this.state.addNpi) {
            this.state.ProviderNPIs.forEach((item) => {
              values.DeleteNPI.push({ NPINumber: item });
            });
          }
          if (this.state.DeleteNPI.length > 0) {
            this.state.DeleteNPI.forEach((item) => {
              values.DeleteNPI.push({ NPINumber: item });
            });
          }

          if (this.state.DeleteTaxID.length > 0) {
            this.state.DeleteTaxID.forEach((item) => {
              values.DeleteTax.push({ TaxNumber: item });
            });
          }

          if (this.state.TaxID.length > 0 && this.state.addTax) {
            this.state.TaxID.forEach((item) => {
              values.DeleteTax.push({ TaxNumber: item });
            });
          }
        }
        values.Tenantid = TenantID;
        values.EligibilityOnlyFlag = this.state.EligibilityOnly === "yes";
        values.IsDSNP = this.state.IsDSNP;

        
        // remove duplicate NPINumber and TaxID passing
        values.DeleteNPI = [...new Map(values.DeleteNPI.map(item => [item.NPINumber, item])).values()]
        values.DeleteTax = [...new Map(values.DeleteTax.map(item => [item.TaxNumber, item])).values()]
        values.DeleteTaxNpiMapping = [...new Map(values.DeleteTaxNpiMapping.map(item => [item.TaxID, item])).values()];
        values.DeleteTaxNpiMapping.forEach(item => {
          item.NPIList = [...new Map(item.NPIList.map(n => [n.NPINumber, n])).values()];
        });
        // Remove invalid TaxID records and clean NPIList
        values.DeleteTaxNpiMapping = values.DeleteTaxNpiMapping
          .map(item => ({
            ...item,
            NPIList: [
              ...new Map(
                (item.NPIList || [])
                  .filter(n => n.NPINumber) // remove empty NPINumber objects
                  .map(n => [n.NPINumber, n])
              ).values()
            ]
          }))
          .filter(
            item =>
              item.TaxID &&
              !Array.isArray(item.TaxID) &&
              item.NPIList.length > 0
          );
            ///// check Group user and add tax id conbination 
          console.log("updated result---",mergedResult);
          if (this.state.SelectValue === "Group User") {

  //  Handle undefined mergedResult
  const safeMergedResult = Array.isArray(mergedResult)
    ? mergedResult
    : [];
 
  const result = safeMergedResult
    .filter(item => item && item.taxId && item.taxId !== "None")
            .map(item => ({
              TaxID: item.taxId,
              NPIList: (item.npis || [])
                .filter(npi => npi && !npi.delete && npi.npi)
                .map(npi => ({
                  NPINumber: npi.npi
                }))
    }))
    .filter(item => item.NPIList.length > 0);
 
  console.log("TaxNpiMapping", result);
  values.TaxNpiMapping = result;
 
  // Preserve existing standalone NPI functionality
  const noneTaxIdRecord = (
    this.state.readytosaveNPIlist || []
  ).find(
    item =>
      item.taxId === "None" &&
      Array.isArray(item.npis) &&
      item.npis.length > 0
  );
 
  values.AddNPI = [];
 
  if (noneTaxIdRecord) {
    values.AddNPI = noneTaxIdRecord.npis
      .filter(item => item && !item.delete && item.npi)
      .map(item => ({
        NPINumber: item.npi
      }));
  }
 
  console.log("Final TaxNpiMapping:", values.TaxNpiMapping);
  console.log("Final AddNPI:", values.AddNPI);
} 
        /// Provider changes on same TAxid 
        console.log(this.props)
        console.log( "existingRoles",this.state.existingRoles)
        const hadProviderRole = this.state.existingRoles && this.state.existingRoles.includes("Provider");
        const providerRemoved = hadProviderRole && this.state.SelectValue !== "Provider";
        if (providerRemoved) {
          values.DeleteNPI = this.state.providercombination
            .flatMap(item => item.npis || [])
            .map(npiItem => ({
              NPINumber: npiItem.npi
            }));
        }
        if (
          this.state.existingRoles.includes("Provider") &&
          this.state.SelectValue === "Provider"
        ) {
          // NPIs that were saved earlier but are no longer in the final list
          const finalNpis = new Set((values.AddNPI || []).map((i) => String(i.NPINumber)));
          const removedNpis = [];
          (this.state.Existingprovidercombination || []).forEach((ex) => {
            (ex.npis || []).forEach((n) => {
              const v = String(n.npi);
              if (v && !finalNpis.has(v)) removedNpis.push({ NPINumber: v });
            });
          });
          values.DeleteNPI = removedNpis;
        }
        console.log(this.state.providercombination)
        console.log(this.state.Existingprovidercombination)
   //// Provider but diffent taxid and NIPS 
      const currentTaxIds = new Set(
        (this.state.providercombination || []).map(item => item.taxId)
      );  
      (this.state.Existingprovidercombination || []).forEach(existing => {
        if (!currentTaxIds.has(existing.taxId)) {
          values.DeleteTax.push({
            TaxNumber: existing.taxId
          });
      
          (existing.npis || []).forEach(npiItem => {
            values.DeleteNPI.push({
              NPINumber: String(npiItem.npi)
            });
          });
        }
      });        
      values.DeleteNPI = [
        ...new Map((values.DeleteNPI || []).map((i) => [String(i.NPINumber), i])).values(),
      ];


        values.IsDSNP = this.state.IsDSNP;


        // Change role from Group User to Provider
        if (
          this.state.existingRoles.includes("Group User") &&
          this.state.SelectValue === "Provider"
        ) {
          // 1. Get old standalone Group User NPIs (taxId: "None")
          const oldGroupNPIs = (this.state.oldCombinations || [])
            .filter(item => item.taxId === "None")
            .flatMap(item => item.npis || [])
            .filter(item => item.save && item.npi)
            .map(item => ({
              NPINumber: String(item.npi)
            }));
 
          // 2. Add old Group User NPIs to DeleteNPI
          values.DeleteNPI = [
            ...(values.DeleteNPI || []),
            ...oldGroupNPIs
          ];
 
          // 3. Delete old Group User TaxID-NPI mappings
          const oldMappings = Array.isArray(
            this.props.userData.TaxNPIMappings
          )
            ? this.props.userData.TaxNPIMappings.map(item => ({
              TaxID: item.TaxID,
              NPIList: item.NPIList
                ? item.NPIList
                  .split(",")
                  .map(npi => npi.trim())
                  .filter(Boolean)
                  .map(npi => ({
                    NPINumber: Number(npi)
                  }))
                : []
            }))
            : [];
 
          values.DeleteTaxNpiMapping = [
            ...(values.DeleteTaxNpiMapping || []),
            ...oldMappings
          ];
 
          // 4. Remove duplicate NPIs
          values.DeleteNPI = [
            ...new Map(
              values.DeleteNPI.map(item => [
                String(item.NPINumber),
                item
              ])
            ).values()
          ];
 
          console.log("Old Group User NPIs:", oldGroupNPIs);
          console.log("Final DeleteNPI:", values.DeleteNPI);
          console.log("Final DeleteTaxNpiMapping:", values.DeleteTaxNpiMapping
          );
        }
 
 
      ///checking taxid values if not selected any taxid need to send empty array
      values.AddTax = (values.AddTax || []).filter(item => {
        if (Array.isArray(item.TaxNumber)) {
          return item.TaxNumber.length > 0;
        }
        return item.TaxNumber;
      });
 
 
      if(this.state.SelectValue === "Plan Admin"){
       
        if (
          Array.isArray(this.state.combinations) &&
          this.state.combinations.length > 0
        ) {
          values.DeleteNPI = this.state.combinations.flatMap((item) =>
            (Array.isArray(item.npis) ? item.npis : [])
              .filter((npiItem) => npiItem.npi && npiItem.npi.trim() !== "")
              .map((npiItem) => ({
                NPINumber: npiItem.npi,
                // TaxID:
                //   !item.taxId || item.taxId === "None"
                //     ? null
                //     : item.taxId,
                // delete: npiItem.delete,
                // save: npiItem.save,
              }))
          );
        } else {
          values.DeleteNPI = [];
        }
      }
        console.log("values",values)

        let data = await fetch(Config.api + "/EditUser", {
          method: "POST",
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
            Accept: "application/json",
            "Content-type": "application/json",
          },
          body: JSON.stringify(values),
        });
        data = await data.json();
        this.setState({
          isLoading: false,
        });

        if (
          data.Message.toUpperCase() === "USER UPDATED SUCCESSFULLY" ||
          data.Message ===
            "User updated successfully with only unique combinations of TINs and NPIs"
        ) {
          this.openNotification(data);
          this.props.form.resetFields();
          this.setState({
            ProviderNPIs: [],
            TaxID: [],
            // AddRole: [],
          });
          updateUserList.next("update");
          this.props.getType("List");
          if (
            this.props.userData.Email == sessionStorage.getItem("userEmail")
          ) {
            //alert("same email")
            let url = Config.api + "/getLoginInformation";
            fetch(url, {
              method: "POST",
              headers: {
                Authorization: sessionStorage.getItem("access_token"),
                // "Authorization" : "Basic VXNlcjE6cGFzczEyMw==",
                Accept: "application/json",
                "Content-type": "application/json",
              },

              body: JSON.stringify({
                Email: this.props.userData.Email,
                TenantID: sessionStorage.getItem("Tanent"),
              }),
            })
              .then((response) => response.json())
              .then((responsejson) => {
                sessionStorage.setItem(
                  "IPAList",
                  responsejson.IPATAXIDMapping.map((item) => `"${item.IPA}"`)
                );
                localStorage.setItem(
                  "SurveyPreference",
                  responsejson.SurveyPreference
                );
                localStorage.setItem(
                  "HoursSinceLastLogin",
                  responsejson.HoursSinceLastLogin
                );
                // console.log('responsejson');
              });
          }
        } else {
          this.openNotification(data);
        }
          }
      //this.props.form.resetFields();
    });
  };
  openNotification = (res) => {
    notification.open({
      description:
        res.Message === "" ? "Email ID already Exist !" : res.Message,
      // onClick: () => {
      // },
    });
  };
  handleChange = (value) => {
    if (value != null) {
      var today = new Date();
      var todaysmonth = String(today.getMonth() + 1).padStart(2, "0");
      var agemonth = value.format("MM/DD/YYYY").split("/")[0];
      var thisYear = 0;
      if (todaysmonth < agemonth) {
        thisYear = 1;
      } else if (todaysmonth == agemonth && todaysmonth < agemonth) {
        thisYear = 1;
      }
      var age =
        today.getFullYear() -
        value.format("MM/DD/YYYY").split("/")[2] -
        thisYear;
      this.setState({
        CurrentAge: age,
      });
    }
  };

  validateTaxAndNpi = (type, value) => {
    if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
      let npi = sessionStorage.getItem("npivalue");
      let taxId = sessionStorage.getItem("taxid");
      if (type === "npi" && value == npi) return true;
      if (type === "taxId" && value == taxId) return true;
      else return false;
    } else return true;
  };

  addItem(e) {
    this.setState({
      // addNpi: true
    });
    e.preventDefault();
    const delet = this.state.DeleteNPI.indexOf(this.newItem.value);
    if (delet > -1) {
      this.state.DeleteNPI.pop(delet);
    }
    const { ProviderNPIs } = this.state;
    const newItem = this.state.addedNpi;
    
    // const isONTheList = ProviderNPIs.includes(newItem);

    if (!this.validateTaxAndNpi("npi", this.state.addedNpi)) {
      this.setState({
        accessDeniedForNpi: true,
        addNpi: false,
      });
      return;
    } else {
      if (newItem) {
        this.setState({
          ProviderNPIs: [newItem],
          addNpi: true,
        });
      } else {
        this.setState({
          disabledNPI: true,
        });
      }
      this.setState({ accessDeniedForNpi: false });
    }
    
    // this.addForm1.reset();
  }

  addItemTax(e) {
    
    this.setState({
      // addTax: true
    });
    e.preventDefault();
    const delet = this.state.DeleteTaxID.indexOf(this.newItemTax.value);
    if (delet > -1) {
      this.state.DeleteTaxID.pop(delet);
    }
    const { TaxID } = this.state;
    const newItemTax = this.state.addedTaxId;
    // const isONTheListTax = TaxID.includes(newItemTax);

    if (!this.validateTaxAndNpi("taxId", this.state.addedTaxId)) {
      this.setState({
        addTax: false,
        accessDeniedForTaxId: true,
      });
    } else {
      if (newItemTax) {
        this.setState({
          TaxID: [newItemTax],
          addTax: true,
        });
      } else {
        this.setState({
          disabled: true,
        });
      }
      this.setState({ accessDeniedForTaxId: false });
    }
    // this.addForm.reset();
  }

  validateUser = () => {
    if (!this.state.UserType) return false;
    if (
      this.state.UserType &&
      (this.state.SelectValue === "Not Required" ||
        this.state.SelectValue === "Plan Admin")
    )
      return true;
    if (
      this.state.SelectValue === "Provider" &&
      this.state.ProviderNPIs.length > 0 &&
      this.state.TaxID.length > 0
    )
      return true;
    if (this.state.SelectValue === "Group User") {
      if (this.state.combinations.filter((item) => !item.delete).length === 0) {
        return false;
      }
      return true;
    }
    if (
      this.state.SelectValue === "IPA User" &&
      this.state.combinations1.length > 0
    )
      return true;
    else return false;
  };
  removeItem(item) {
    this.setState({
      disabledaccordingtoinput: true,
      Npiclicked: false,
    });
    this.state.DeleteNPI.push(item);
    const newProviderNPIs = this.state.ProviderNPIs.filter((ProviderNPIs) => {
      return ProviderNPIs !== item;
    });
    this.setState({
      ProviderNPIs: [...newProviderNPIs],
      disabledNPI: false,
      addNpi: false,
    });
  }

  removeItemTax(item) {
    this.setState({
      disabledaccordingtoinputTax: true,
      Taxclicked: false,
    });
    this.state.DeleteTaxID.push(item);
    const newTaxID = this.state.TaxID.filter((TaxID) => {
      return TaxID !== item;
    });
    this.setState({
      TaxID: [...newTaxID],
      disabled: false,
      addTax: false,
    });
  }

  getEmailId = (email) => {
    this.props.userData.Email = email.target.value;
  };

  handleReset = () => {
    this.props.getType("List");
    this.setState({
      SelectValue: "",
      CurrentAge: "",
      AddRole: [],
      Geticon: false,
      clicked: false,
    });
  };

  checkUserRole = (role) => {
    let userRoles = sessionStorage.getItem("rolename");
    return userRoles.includes(role);
  };

  render() {

    

    const providerList = this.props.userData?.Provider_NPI_TAXID || [];
    const allTaxIds = [
      ...new Set(providerList.map(item => item.TaxID).filter(Boolean))
    ].join(", ");
    
    const allNpis = [
      ...new Set(providerList.map(item => item.NPI).filter(Boolean))
    ].join(", ");

   // console.log("storeByDefaultIPAsnew",this.state.storeByDefaultIPAs)
    const allowedPlans = ["csh", "ultimate", "solis", "sonder", "PodAmerica"];
    const planName = sessionStorage.getItem("planName")?.toLowerCase();
    const showDsnpQuestion =
    this.state.SelectValue === "Plan Admin" &&
    allowedPlans.includes(planName);

    const isDsnpValid =
      !showDsnpQuestion ||
      this.state.IsDSNP === 0 ||
      this.state.IsDSNP === 1;

    let Rolecount = 0;
    const { Option } = Select;
    const { getFieldDecorator } = this.props.form;
    const { ProviderNPIs, TaxID } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 5 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    return (
      <div>
        <div class="square-blue-profile">
          <Row
            className="ml-4"
            type="flex"
            justify-content="space-start"
            align="middle"
            style={{ padding: "10px" }}
          >
            <Col>
              <div
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                {this.props.activeTab === "RegisteredUsers" ? (
                  <>User Information</>
                ) : (
                  <> User Information</>
                )}
              </div>
            </Col>
            <Col push={18} className="ml-4"></Col>
          </Row>
        </div>

        {this.props.userData && this.props.activeTab === "RegisteredUsers" && (
          <Form
            {...formItemLayout}
            // onSubmit={this.handleSubmit}
          >
            <div className="flex-container">
              {/* Personal Information */}
              <div className="flex-child">
                <div className="square-white-adduser-personalInformation ml-4 mb-5">
                  <div className="PersonalInformation">
                    Personal Information
                  </div>
                  <br />
                  <Row>
                    <Col span={6} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        First Name
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("FirstName", {
                          initialValue: this.props.userData.FirstName,
                        })(
                          <Input
                            disabled
                            size="lg"
                            placeholder="Enter"
                            maxLength="24"
                          />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={6} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Middle Name
                      </div>
                      <Form.Item>
                        {getFieldDecorator("MiddleName", {
                          initialValue: this.props.userData.MiddleName,
                        })(
                          <Input
                            disabled
                            size="lg"
                            placeholder="Enter"
                            maxLength="24"
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={6} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Last Name
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("LastName", {
                          initialValue: this.props.userData.LastName,
                          rules: [
                            {
                              required: true,
                              message: "   ",
                            },
                            {
                              pattern: new RegExp("^[a-zA-Z' ']*$"),
                              message: "Enter Alphabets Only!",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>
                    
                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Name
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("Name", {
                          initialValue: "",
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Provider Name
                      </div>
                      <Form.Item>
                        {getFieldDecorator("ProviderName", {
                          initialValue: this.props.userData.ProviderName,
                        })(
                          <Input
                            disabled
                            size="lg"
                            placeholder="Enter"
                            maxLength="24"
                          />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={6} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Job Title
                      </div>
                      <Form.Item>
                        {getFieldDecorator("IsAdmin", {
                          initialValue: this.props.userData.JobTitle,
                        })(
                          <Input
                            disabled
                            size="lg"
                            placeholder="Enter"
                            maxLength="24"
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <br />
                  <br />

                  <br />
                </div>
              </div>

              {/* Contact Information */}
              <div className="flex-child">
                <div className="square-white-adduser-EnterContactInformation mr-5 mb-5">
                  <div className="ContactInformation ">Contact Info</div>
                  <br />
                  <Row>
                    <Col span={12} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Contact No.
                      </div>
                      <Form.Item>
                        {getFieldDecorator("PhoneNumber", {
                          initialValue: this.props.userData.ContactNumber,
                        })(
                          <Input
                            disabled
                            size="lg"
                            placeholder="Enter"
                            maxLength="24"
                            style={{ width: "130px" }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={12} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{
                          fontWeight: "600",
                          fontSize: "12px",
                        }}
                      >
                        Fax No.
                      </div>
                      <Form.Item>
                        {getFieldDecorator("fax", {
                          initialValue: this.props.userData.FaxNumber,
                        })(
                          <Input
                            disabled
                            size="lg"
                            placeholder="Enter"
                            maxLength="24"
                            style={{ width: "130px" }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <br />
                  <br />
                  <Row>
                    <Col span={24} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Email ID
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("username", {
                          initialValue: this.props.userData.EmailID,
                        })(
                          <Input
                            disabled
                            size="lg"
                            placeholder="Enter"
                            style={{ width: "312px" }}
                            onChange={this.getEmailId}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <div className="ml-4">
                      Username: {this.props.userData.EmailID}
                    </div>
                  </Row>
                  <br />
                </div>
              </div>
            </div>
            {/*Location Information*/}
            <div className="square-white-adduser-LocationInformation ml-4 mb-5">
              <div className="LocationInformation">Location Information</div>
              <br />
              <Row className="mr-5">
                <Col span={3} className="ml-4">
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    Address 01
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </div>
                  <Form.Item>
                    {getFieldDecorator("Address", {
                      initialValue: this.props.userData.Address01,
                    })(
                      <Input
                        disabled
                        placeholder="Select"
                        style={{ width: "160px" }}
                        size="lg"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={1}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    Address 02
                  </div>
                  <Form.Item>
                    {getFieldDecorator("address2", {
                      initialValue: this.props.userData.Address02,
                    })(
                      <Input
                        disabled
                        placeholder="Select"
                        style={{ width: "160px" }}
                        size="lg"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={2}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    City
                  </div>
                  <Form.Item>
                    {getFieldDecorator("city", {
                      initialValue: this.props.userData.City,
                    })(
                      <Input
                        disabled
                        placeholder="Select"
                        style={{ width: "160px" }}
                        size="lg"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={3}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    State
                  </div>
                  <Form.Item>
                    {getFieldDecorator("state", {
                      initialValue: this.props.userData.State,
                    })(
                      <Input
                        disabled
                        size="lg"
                        placeholder="Enter"
                        style={{ width: "160px" }}
                        maxLength="24"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={4}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    Zipcode
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </div>
                  <Form.Item>
                    {getFieldDecorator("zip", {
                      initialValue: this.props.userData.ZipCode,
                    })(
                      <Input
                        disabled
                        size="lg"
                        placeholder="Enter"
                        style={{ width: "160px" }}
                        maxLength="24"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={5}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    Country
                  </div>
                  <Form.Item>
                    {getFieldDecorator("country", {
                      initialValue: this.props.userData.Country,
                    })(
                      <Input
                        disabled
                        size="lg"
                        placeholder="Enter"
                        style={{ width: "160px" }}
                        maxLength="24"
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <br />
              <br />
            </div>

            {/*Select Role*/}
            <div className="square-white-adduser-Role  ml-4 mb-5 px-2">
              {/* <div className="LocationInformation">Select Role</div> */}
              {/* <Row> */}
              <div className="p-2 PersonalInformation mb-4"> Access Level</div>

              <div className="p-2">
                <Card>

                <Row gutter={16}>
                 {/* Role */}
                 <Col style={{marginLeft:"20px"}}span={4}>

                    <div
                      className="form-text-decorator ml-1 mt-2"
                    >
                      Role
                    </div>
                    <Form.Item>
                      {getFieldDecorator("role", {
                        initialValue: this.props.userData.AccessLevel,
                      })(
                        <Input
                          disabled
                          size="lg"
                        />

                      )}
                    </Form.Item>
                  </Col> 
                  

                    {/* Tax ID */}
                    {(this.props.userData.AccessLevel === "Provider" ||
                      this.props.userData.AccessLevel === "Group User") && (
                        <>
                          <Col span={4}>
                            <div className="form-text-decorator ml-1 mt-2">
                              Tax ID
                            </div>

                            <Form.Item>
                              <Tooltip title={allTaxIds}>
                              <span>
                                {getFieldDecorator("taxId", {
                                  initialValue: allTaxIds || "---",
                                })(
                                  <Input disabled size="lg" />
                                )}


                                </span>
                              </Tooltip>
                            </Form.Item>


                          </Col>



                          {/* NPI */}
                          <Col span={4}>
                            <div className="form-text-decorator ml-1 mt-2">
                              NPI
                            </div>

                            <Form.Item>
                              <Tooltip title={allNpis}>
                              <span>
                                {getFieldDecorator("npi", {
                                  initialValue: allNpis || "---",
                                })(
                                  <Input disabled size="lg" />
                                )}
                                </span>
                              </Tooltip>
                            </Form.Item>
                          </Col>
                        </>
                      )}
                  </Row> 




                </Card>
                {
                  this.checkUserRole("Plan Admin") &&
                  <Card className="card-css pl-2 pr-2 pt-1 pb-1 mb-3">
                    <Row>
                      <Col span={20} className="question-css">
                        01. Do you want to assign User-Admin privileges to the
                        user ?<span style={{ color: "#D14A4A" }}>*</span>
                      </Col>
                      <Col span={4} style={{ textAlign: "right" }}>
                        <Radio.Group
                          onChange={(e) => this.onChange(e, "admin")}
                          value={this.state.UserType}
                        >
                          <Radio
                            value={1}
                            className="question-css"
                            disabled={!this.checkUserRole("Plan Admin")}
                          >
                            Yes
                          </Radio>
                          <Radio
                            value={2}
                            className="question-css"
                            disabled={!this.checkUserRole("Plan Admin")}
                          >
                            No
                          </Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                  </Card>
                }
                {
                  this.state.UserType &&
                  this.state.RoleWithOptions != "" && sessionStorage.getItem("planName") !== "ultimate" && (
                    <Card className="card-css pl-2 pr-2 pt-1 pb-1">
                      <Row>
                        <Col span={10} className="question-css">
                          {!this.checkUserRole("Plan Admin") ? "01. " : "02. "}{" "}
                          Should the user have Eligibility Only permissions ?{" "}
                          <span style={{ color: "#D14A4A" }}>*</span>
                        </Col>
                        <Col span={14} style={{ textAlign: "right" }}>
                          <Radio.Group
                            onChange={(e) => this.onChange(e, "e&b")}
                            value={this.state.EligibilityOnly}
                          >
                            <Radio value={"yes"} className="question-css">
                              Yes
                            </Radio>
                            <Radio value={"no"} className="question-css">
                              No
                            </Radio>
                          </Radio.Group>
                        </Col>
                      </Row>
                      <span
                        style={{
                          color: "orange",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >
                        Setting this user permission as "Yes" will enable access
                        to Eligibility Check page only and <br />
                        user will be restricted from access any other
                        information on the website apart from member's
                        eligibility.
                      </span>
                    </Card>
                  )
                }
              </div>
            </div>
            <div>
              <Row className="mx-5 pb-3">
                <Col span={12}>
                  <button
                    disabled={this.state.disableButton}
                    className="cancle-button pl-4 pr-4"
                    onClick={this.handleIPACancle}
                    htmlType="submit"
                  >
                    Cancel
                  </button>
                </Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  <button
                    // style={{ marginLeft: "72%" }}
                    disabled={this.state.disableButton}
                    className="cancle-button pl-4 pr-4"
                    onClick={() => this.handleIPASubmit("Denied")}
                    htmlType="submit"
                  >
                    Deny
                  </button>

                  <button
                    disabled={this.state.disableButton}
                    htmlType="submit"
                    className="ml-3 butto-alluser pl-4 pr-4"
                    style={{
                      backgroundColor: this.state.disableButton ? "#a0cfff" : "#1890ff",
                      cursor: this.state.disableButton ? "not-allowed" : "pointer"
                    }}
                    onClick={() => this.handleIPASubmit("Approved")}
                  >
                    Approve
                  </button>

                  {this.state.isLoadingApprove && (
                    <span  style={{marginLeft:"20px"}}>
                      <Spin size="large" />
                    </span>
                  )}
                </Col>
              </Row>
            </div>
          </Form>
        )}

        {this.props.userData && this.props.userData.UserName && (
          <Form
            {...formItemLayout}
            // onSubmit={this.handleSubmit}
          >
            <div className="flex-container">
              {/* Personal Information */}
              <div className="flex-child">
                <div className="square-white-adduser-personalInformation ml-4 mb-5">
                  <div className="PersonalInformation">
                    Enter Personal Information
                  </div>
                  <br />
                  <Row>
                    <Col span={6} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        First Name
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("FirstName", {
                          initialValue:
                            this.props.userData.UserName.split(" ")[0],
                          rules: [
                            {
                              required: true,
                              message: "   ",
                            },
                            {
                              pattern: new RegExp("^[a-zA-Z' ']*$"),
                              message: "Enter Alphabets Only!",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Id
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("Id", {
                          initialValue: this.props.userData.ID,

                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Tanent ID
                      </div>
                      <Form.Item>
                        {getFieldDecorator("Tenantid", {
                          initialValue: "",
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Tanent ID
                      </div>
                      <Form.Item>
                        {getFieldDecorator("URL", {
                          initialValue: sessionStorage.getItem("url"),
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={6} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Middle Name
                      </div>
                      <Form.Item>
                        {getFieldDecorator("MiddleName", {
                          initialValue:
                            this.props.userData.UserName.split(" ")[2] ===
                            undefined
                              ? ""
                              : this.props.userData.UserName.split(" ")[1],
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                            {
                              pattern: new RegExp("^[a-zA-Z' ']*$"),
                              message: "Enter Alphabets Only!",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={6} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Last Name
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("LastName", {
                          initialValue:
                            this.props.userData.UserName.split(" ")[2] ===
                            undefined
                              ? this.props.userData.UserName.split(" ")[1]
                              : this.props.userData.UserName.split(" ")[2],
                          rules: [
                            {
                              required: true,
                              message: "   ",
                            },
                            {
                              pattern: new RegExp("^[a-zA-Z' ']*$"),
                              message: "Enter Alphabets Only!",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Name
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("Name", {
                          initialValue: "",
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Tax
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("AddTax", {
                          initialValue: "",
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        NPI
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("AddNPI", {
                          initialValue: "",
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={6} push={1} hidden>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        IsAdmin
                      </div>
                      <Form.Item>
                        {getFieldDecorator("IsAdmin", {
                          initialValue: sessionStorage.getItem("AdminRole"),
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input size="lg" placeholder="Enter" maxLength="24" />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={6} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Gender
                      </div>
                      <Form.Item>
                        {getFieldDecorator("Gender", {
                          initialValue: this.props.userData.gender,
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                          ],
                        })(
                          <Select placeholder="Select" size="lg">
                            <Option value="Male">Male</Option>
                            <Option value="Female">Female</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <br />
                  <br />
                  <Row></Row>
                  <br />
                </div>
              </div>
              {/* Contact Information */}
              <div className="flex-child">
                <div className="square-white-adduser-EnterContactInformation mr-5 mb-5">
                  <div className="ContactInformation ">
                    Enter Contact information
                  </div>
                  <br />
                  <Row>
                    <Col span={12} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Contact No.
                      </div>
                      <Form.Item>
                        {getFieldDecorator("PhoneNumber", {
                          initialValue: this.props.userData.PhoneNumber,
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                            {
                              pattern: new RegExp("^[0-9]*$"),
                              message: "Enter Numbers Only!",
                            },
                          ],
                        })(
                          <Input
                            size="lg"
                            placeholder="Enter"
                            maxLength="24"
                            style={{ width: "130px" }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={12} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{
                          fontWeight: "600",
                          fontSize: "12px",
                        }}
                      >
                        Fax No.
                      </div>
                      <Form.Item>
                        {getFieldDecorator("fax", {
                          initialValue: this.props.userData.FaxID,
                          rules: [
                            {
                              required: false,
                              message: "   ",
                            },
                            {
                              pattern: new RegExp("^[0-9+-]*$"),
                              message: "Enter Numbers Only!",
                            },
                          ],
                        })(
                          <Input
                            size="lg"
                            placeholder="Enter"
                            maxLength="24"
                            style={{ width: "130px" }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <br />
                  <br />
                  <Row>
                    <Col span={24} push={1}>
                      <div
                        className="form-text-decorator ml-1 mt-2"
                        style={{ fontWeight: "600", fontSize: "12px" }}
                      >
                        Email ID
                        <span style={{ color: "red" }}>*</span>
                      </div>
                      <Form.Item>
                        {getFieldDecorator("username", {
                          initialValue: this.props.userData.Email,
                          rules: [
                            {
                              required: true,
                              message: "   ",
                            },
                          ],
                        })(
                          <Input
                            disabled
                            size="lg"
                            placeholder="Enter"
                            style={{ width: "312px" }}
                            onChange={this.getEmailId}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <div className="ml-4">
                      Username: {this.props.userData.Email}
                    </div>
                  </Row>
                  <br />
                </div>
              </div>
            </div>
            {/*Location Information*/}
            <div className="square-white-adduser-LocationInformation ml-4 mb-5">
              <div className="LocationInformation">
                Enter Location Information
              </div>
              <br />
              <Row className="mr-5">
                <Col span={3} className="ml-4">
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    Address 01
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </div>
                  <Form.Item>
                    {getFieldDecorator("Address", {
                      initialValue: this.props.userData.Address,
                      rules: [
                        {
                         //  required: true,
                          message: "   ",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Select"
                        style={{ width: "160px" }}
                        size="lg"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={1}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    Address 02
                  </div>
                  <Form.Item>
                    {getFieldDecorator("address2", {
                      initialValue: "",
                      rules: [
                        {
                          required: false,
                          message: "   ",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Select"
                        style={{ width: "160px" }}
                        size="lg"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={2}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    City
                  </div>
                  <Form.Item>
                    {getFieldDecorator("city", {
                      initialValue: this.props.userData.City,
                      rules: [
                        {
                          required: false,
                          message: "   ",
                        },
                        {
                          pattern: new RegExp("^[a-zA-Z' ']*$"),
                          message: "Enter Alphabets Only!",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Select"
                        style={{ width: "160px" }}
                        size="lg"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={3}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    State
                  </div>
                  <Form.Item>
                    {getFieldDecorator("state", {
                      initialValue: this.props.userData.State,
                      rules: [
                        {
                          required: false,
                          message: "   ",
                        },
                        {
                          pattern: new RegExp("^[a-zA-Z' ']*$"),
                          message: "Enter Alphabets Only!",
                        },
                      ],
                    })(
                      <Input
                        size="lg"
                        placeholder="Enter"
                        style={{ width: "160px" }}
                        maxLength="24"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={4}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    Zipcode
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </div>
                  <Form.Item>
                    {getFieldDecorator("zip", {
                      initialValue: this.props.userData.ZipCode,
                      rules: [
                        {
                         // required: true,
                          message: "   ",
                        },
                        {
                          pattern: new RegExp("^[0-9]*$"),
                          message: "Enter Numbers Only!",
                        },
                      ],
                    })(
                      <Input
                        size="lg"
                        placeholder="Enter"
                        style={{ width: "160px" }}
                        maxLength="24"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={3} push={5}>
                  <div
                    className="form-text-decorator ml-1 mt-2"
                    style={{ fontWeight: "600", fontSize: "12px" }}
                  >
                    Country
                  </div>
                  <Form.Item>
                    {getFieldDecorator("country", {
                      initialValue: this.props.userData.Country,
                      rules: [
                        {
                          required: false,
                          message: "   ",
                        },
                        {
                          pattern: new RegExp("^[a-zA-Z' ']*$"),
                          message: "Enter Alphabets Only!",
                        },
                      ],
                    })(
                      <Input
                        size="lg"
                        placeholder="Enter"
                        style={{ width: "160px" }}
                        maxLength="24"
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <br />
              <br />
            </div>

            {/*Select Role*/}
            <div className="square-white-adduser-Role  ml-4 mb-5 px-2">
              {/* <div className="LocationInformation">Select Role</div> */}
              {/* <Row> */}
              <div className="p-2 PersonalInformation mb-4"> Assign Role</div>

              <div className="p-2">
                {this.checkUserRole("Plan Admin") && (
                  <Card className="card-css pl-2 pr-2 pt-1 pb-1 mb-3">
                    <Row>
                      <Col span={20} className="question-css">
                        01. Do you want to assign User-Admin privileges to the
                        user ?<span style={{ color: "#D14A4A" }}>*</span>
                      </Col>
                      <Col span={4} style={{ textAlign: "right" }}>
                        <Radio.Group
                          onChange={(e) => this.onChange(e, "admin")}
                          value={this.state.UserType}
                        >
                          <Radio
                            value={1}
                            className="question-css"
                            disabled={!this.checkUserRole("Plan Admin")}
                          >
                            Yes
                          </Radio>
                          <Radio
                            value={2}
                            className="question-css"
                            disabled={!this.checkUserRole("Plan Admin")}
                          >
                            No
                          </Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                  </Card>
                )}
                {/* </div> */}



                <div className="pb-3">
                  {
                    <Card className="card-css pl-2 pr-2 pt-1 pb-1">
                      <Row>
                        <Col span={10} className="question-css">
                          {this.checkUserRole("Plan Admin") ? "02. " : "01. "}{" "}
                          Please select one role for the user.{" "}
                          <span style={{ color: "#D14A4A" }}>*</span>
                        </Col>
                        <Col span={14} style={{ textAlign: "right" }}>
                          <Radio.Group
                            onChange={this.ChangeWithOptions}
                            value={this.state.RoleWithOptions}
                          >
                            {this.checkUserRole("Plan Admin") && (
                              <Radio value={"PA1"} className="question-css">
                                Plan Admin
                              </Radio>
                            )}
                            {(this.checkUserRole("Group User") ||
                              this.checkUserRole("Plan Admin") ||
                              this.checkUserRole("IPA User")) && (
                              <Radio value={"GA1"} className="question-css">
                                Group User
                              </Radio>
                            )}
                            {(this.checkUserRole("IPA User") ||
                              this.checkUserRole("Plan Admin")) &&  sessionStorage.getItem("planName") !== "secur" && (
                              <Radio
                                value={"IPA User"}
                                className="question-css"
                              >
                                IPA User
                              </Radio>
                            )}
                            {(this.checkUserRole("Provider") ||
                              this.checkUserRole("Plan Admin")) && (
                              <Radio value={"PR1"} className="question-css">
                                Provider
                              </Radio>
                            )}
                          </Radio.Group>
                        </Col>
                      </Row>
                    </Card>
                  }

                  {(this.state.SelectValue === "Provider" ||
                    this.state.SelectValue === "Group User" ||
                    this.state.SelectValue === "IPA User") && (
                    <div className="p-2 group-admin-block">
                      {this.state.SelectValue === "Provider" ? (
                        <div className="mx-4 mt-2">
                          <ProviderTaxid
                           List="Edit"
                          savedNpiList={this.props.userData.NPIList}
                          setProviderCombinations={this.setProviderCombinations}
                          setCombinations={this.setCombinations}
                          getCombinations={this.state.providercombination}
                          setDeletedCombinations={this.setDeletedCombinations}
                          getsavedlistdate = {this.savedTaxidAndNPIList}
                        />
                        </div>
                      ) : this.state.SelectValue === "Group User" ? (
                        <GroupAdmin
                          npiListForGroupUserNpi={this.state.npiListForGroupUserNpi}
                          savedNpiList={this.props.userData.NPIList}
                          setCombinations={this.setCombinations}
                          getCombinations={this.state.combinations}
                          setDeletedCombinations={this.setDeletedCombinations}
                          getsavedlistdate = {this.savedTaxidAndNPIList}
                        />
                      ) : this.state.SelectValue === "IPA User" ? (
                        <AddIPAs2
                          // key={this.state.componentKey}
                          setCombinations1={this.setCombinations1}
                          getCombinations1={this.state.combinations1}
                          setTaxIDandNPIDetailsByIPA={
                            this.setTaxIDandNPIDetailsByIPA
                          }
                          getTaxIDandNPIDetailsByIPA={
                            this.state.taxIDandNPIDetailsByIPA
                          }
                          setEditClick={this.SeteditClickForIPAs}
                          setUpdateClick={this.SetupdateClickForIPAs}
                          // setDeletedCombinations={this.setDeletedCombinations}
                        />
                      ) : (
                        ""
                      )}
                      <br />
                    </div>
                  )}
                </div>
                {this.checkUserRole("Plan Admin") &&
                  this.state.UserType &&
                  this.state.RoleWithOptions != "" && sessionStorage.getItem("planName") !== "ultimate" && (
                    <Card className="card-css pl-2 pr-2 pt-1 pb-1">
                      <Row>
                        <Col span={10} className="question-css">
                          {this.checkUserRole("Plan Admin") ? "03. " : "02. "}{" "}
                          Should the user have Eligibility Only permissions ?{" "}
                          <span style={{ color: "#D14A4A" }}>*</span>
                        </Col>
                        <Col span={14} style={{ textAlign: "right" }}>
                          <Radio.Group
                            onChange={(e) => this.onChange(e, "e&b")}
                            value={this.state.EligibilityOnly}
                          >
                            <Radio value={"yes"} className="question-css">
                              Yes
                            </Radio>
                            <Radio value={"no"} className="question-css">
                              No
                            </Radio>
                          </Radio.Group>
                        </Col>
                      </Row>
                      <span
                        style={{
                          color: "orange",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >
                        Setting this user permission as "Yes" will enable access
                        to Eligibility Check page only and <br />
                        user will be restricted from access any other
                        information on the website apart from member's
                        eligibility.
                      </span>

                    </Card>                  
                  )}
                   {showDsnpQuestion && (
                  <Card className="card-css pl-2 pr-2 pt-2 pb-1 mb-3">
                    <Row>
                      <Col span={20} className="question-css">
                        {this.checkUserRole("Plan Admin") &&
                          this.checkUserRole("Group User")
                          ? "04. "
                          : "03. "}{" "}
                        Should the user be able to access DSNP Member information ?
                        <span style={{ color: "#D14A4A" }}>*</span>
                      </Col>

                      <Col span={4} style={{ textAlign: "right" }}>
                        <Radio.Group
                          onChange={(e) => this.onChange(e, "isDsnp")}
                          value={this.state.IsDSNP}
                        >
                          <Radio value={1} className="question-css">
                            Yes
                          </Radio>

                          <Radio value={0} className="question-css">
                            No
                          </Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                  </Card>

                 
                  )}
                   
              </div>
            </div>
            <div>
              <Row type="flex" justify="end" className="mx-5 pb-3">
                <Col>
                  <button
                    className="cancle-button pl-4 pr-4"
                    onClick={this.handleReset}
                    htmlType="submit"
                  >
                    Cancel
                  </button>
                  {this.validateUser() &&
                    !this.state.isLoading &&
                    isDsnpValid && (
                      <button
                        htmlType="submit"
                        className="ml-3 butto-alluser pl-4 pr-4"
                        onClick={this.handleSubmit}
                      >
                        Update User
                      </button>
  )}
                  {this.state.isLoading && (
                    <span className="ml-2">
                      <Spin size="small" />
                    </span>
                  )}
                </Col>
              </Row>
            </div>
          </Form>
        )}
      </div>
    );
  }
}
export default Form.create({ name: "editUser" })(editUser);
